export const ReBetCalculate = (gameInfo, gameType = null, betType = null, position = null, amount, bet1, betDicountData, bet2 = null, bet3 = null, shioData = null) => {
    let parsAmount = parseInt(amount)
    let kombinasiData = {
        'as' : 'As',
        'kop' : 'Kop',
        'genap' : 'Genap',
        'ganjil' : 'Ganjil',
        'kecil' : 'Kecil',
        'besar' : 'Besar',
        'ekor' : 'Ekor',
        'kepala' : 'Kepala',
        'depan' : 'Depan',
        'tengah' : 'Tengah',
        'belakang' : 'Belakang',
        'kembang' : 'Kembang',
        'kempis' : 'Kempis',
        'kembar' : 'Kembar',
        'silang' : 'Silang',
        'homo' : 'Homo',
        'tepi' : 'Tepi'
    }
    
    let betAmount = 0;
    let keiDisValue = ''
    let keiKey = ''
    let keiValue = ''
    let betDic = ''
    let winAmount = ''
        
    if(gameInfo === "4D") {
        betDic = betType > 1000 ? 0 : betDicountData.showDisc4d
        keiDisValue = betDicountData.showMenang4d
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "3D Belakang") {
        betDic = betType > 1000 ? 0 : betDicountData.showDisc3d
        keiDisValue = betType == 222 ? betDicountData.showMenang3d : betDicountData.showMenang3dBelakang
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "3D  Depan") {
        betDic = betType > 1000 ? 0 : betDicountData.showDisc3d
        keiDisValue = betType == 222 ? betDicountData.showMenang3d : betDicountData.showMenang3dDepan
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "2D Belakang") {
        betDic = betType > 1000 ? 0 : betDicountData.showDisc2d
        keiDisValue = betDicountData.showMenang2dBelakang
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "2D  Tengah") {
        betDic = betType > 1000 ? 0 : betDicountData.showDisc2d
        keiDisValue = betDicountData.showMenang2dTengah
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "2D  Depan") {
        betDic = betType > 1000 ? 0 : betDicountData.showDisc2d
        keiDisValue = betDicountData.showMenang2dDepan
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "50-50") {
        betAmount = parsAmount - (parsAmount * betDicountData.showDisc) / 100
        keiKey = betType == 222 ? "showMenang5050_"+bet1.replace(' ', '_') : "kei_"+bet1.replace(' ', '_')
        if(keiKey !== '') {
            keiDisValue = betDicountData[keiKey]
        }
        betDic = betType == 222 ? betDicountData.showDisc5050 : betDicountData.showDisc
        if(keiDisValue.toString().includes('-')) {
            keiValue = parsAmount - (parsAmount * (keiDisValue/100))
            betAmount = keiValue - (keiValue * betDic)/100
        }
        else {
            betAmount = parsAmount - (parsAmount * betDic) / 100
        }
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 3)
    }
    else if(gameInfo === "50-50 2D") {
        keiKey = betType == 222 ? "showMenang50502d_"+bet1 : "kei_"+bet1
        if(keiKey !== '') {
            keiDisValue = betDicountData[keiKey]
        }
        betDic = betType == 222 ? betDicountData.showDisc50502d : betDicountData.showDisc
        if(keiDisValue.toString().includes('-')) {
            keiValue = parsAmount - (parsAmount * (keiDisValue/100))
            betAmount = keiValue - (keiValue * betDic)/100
        }
        else {
            betAmount = parsAmount - (parsAmount * betDic) / 100
        }
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 4)
    }
    else if(gameInfo === "Colok Jitu") {
        keiDisValue = betType == 222 ? betDicountData.showMenangColokJitu : betDicountData.showPrize
        betDic = betType == 222 ? betDicountData.showDiscColokJitu : betDicountData.showDisc
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 2)
    }
    else if(gameInfo === "Shio") {
        keiDisValue = betType == 222 ? betDicountData.showMenangShio : betDicountData.showPrize
        betDic = betType == 222 ? betDicountData.showDiscShio : betDicountData.showDisc
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 2)
    }
    else if(gameInfo === "Bebas") {
        keiDisValue = betType == 222 ? betDicountData.showMenangColokBebas : betDicountData.showPrize
        betDic = betType == 222 ? betDicountData.showDiscColokBebas : betDicountData.showDisc
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 2)
    }
    else if(gameInfo === "Bebas 2D") {
        keiDisValue = betType == 222 ? betDicountData.showMenangColokBebas2d : betDicountData.showPrize
        betDic = betType == 222 ? betDicountData.showDiscColokBebas2d : betDicountData.showDisc
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 2)
    }
    else if(gameInfo === "Naga") {
        keiDisValue = betType == 222 ? betDicountData.showMenangColokNaga : betDicountData.showPrize
        betDic = betType == 222 ? betDicountData.showDiscColokNaga : betDicountData.showDisc
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 2)
    }
    else if(gameInfo === "Tengah Tepi") {
        keiDisValue = betType == 222 ? betDicountData[`showMenang${kombinasiData[bet1]}`] : betDicountData[`kei${bet1}`]
        betDic = betType == 222 ? betDicountData.showDiscTengahTepi : betDicountData.showDisc
        if(keiDisValue.toString().includes('-')) {
            keiValue = parsAmount - (parsAmount * (keiDisValue/100))
            betAmount = keiValue - (keiValue * betDic)/100
        }
        else {
            betAmount = parsAmount - (parsAmount * betDic) / 100
        }
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 3)
    }
    else if(gameInfo === "Kombinasi") {
        keiDisValue = betType == 222 ? betDicountData.showMenangKombinasi : betDicountData.showPrize
        betDic = betType == 222 ? betDicountData.showDiscKombinasi : betDicountData.showDisc
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 2)
    }
    else if(gameInfo === "Dasar") {
        keiDisValue = betDicountData[`kei${bet1}`]
        betDic = betDicountData.showDisc
        if(keiDisValue.toString().includes('-')) {
            keiValue = parsAmount - (parsAmount * (keiDisValue/100))
            betAmount = keiValue - (keiValue * betDic)/100
        }
        else {
            betAmount = parsAmount - (parsAmount * betDic) / 100
        }
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 3)
    }
    else if(gameInfo == "Silang Homo") {
        keiKey = betType == 222 ? "showMenangHomo_"+bet1 : "kei_"+bet1.replace(' ', '_')
        keiDisValue = betDicountData[keiKey]
        betDic = betType == 222 ? betDicountData.showDiscSilangHomo : betDicountData.showDisc
        if(keiDisValue.toString().includes('-')) {
            keiValue = parsAmount - (parsAmount * (keiDisValue/100))
            betAmount = keiValue - (keiValue * betDic)/100
        }
        else {
            betAmount = parsAmount - (parsAmount * betDic) / 100
        }
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 3)
    }
    else if(gameInfo === "6D" || gameInfo === "6D Fullbet" || gameInfo === "6D Prize123") {
        let showDisc = '';
        let showMenang = '';

        switch (gameInfo) {
            case "6D":
                showDisc = betDicountData.showDisc6d;
                showMenang = betDicountData.showMenang6d;
                break;
            case "6D Fullbet":
                showDisc = betDicountData.showDisc6dFullbet;
                showMenang = betDicountData.showMenang6dFullbet;
                break;
            case "6D Prize123":
                showDisc = betDicountData.showDisc6dPrize123;
                showMenang = betDicountData.showMenang6dPrize123;
                break;
            default:
                showDisc = betDicountData.showDisc6d;
                showMenang = betDicountData.showMenang6d;
                break;
        }
        betDic = betType > 1000 ? 0 : showDisc
        keiDisValue = showMenang
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else if(gameInfo === "5D" || gameInfo === "5D Fullbet"|| gameInfo === "5D Prize123") {
        let showDisc = '';
        let showMenang = '';

        switch (gameInfo) {
            case "5D":
                showDisc = betDicountData.showDisc5d;
                showMenang = betDicountData.showMenang5d;
                break;
            case "5D Fullbet":
                showDisc = betDicountData.showDisc5dFullbet;
                showMenang = betDicountData.showMenang5dFullbet;
                break;
            case "5D Prize123":
                showDisc = betDicountData.showDisc5dPrize123;
                showMenang = betDicountData.showMenang5dPrize123;
                break;
            default:
                showDisc = betDicountData.showDisc5d;
                showMenang = betDicountData.showMenang5d;
                break;
        }
        betDic = betType > 1000 ? 0 : showDisc
        keiDisValue = showMenang
        betAmount = parsAmount - (parsAmount * betDic) / 100
        winAmount = winAmountCal(parsAmount, betDic, keiDisValue, 1)
    }
    else {
        //
    }
    return [betAmount, winAmount]
}

const winAmountCal = (amount, discount, prize, condition) => {
    let kei = '';
    let bayar = '';
    let total = '';
    kei = (amount * (Math.abs(prize) / 100));
    bayar = (amount - ((amount) * (discount / 100)));
    if(condition == 3) {
        if(prize < 0) {
            bayar = (amount - ((amount+kei) * (discount / 100)));
        }
        total = (amount + bayar + kei);
    }
    else if(condition == 2) {
        total = ((prize * amount) + bayar);
    }
    else if(condition == 4) {
        total = ((amount + bayar) - kei);
    }
    else {
        total = (prize * amount);
    }
    return total
}